(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterComponent extends HTMLElement {
    constructor() {
      super();
      this.bindClick()
    }

    bindClick() {
      $(this).find('.footer-nav-lists .nav-title').on('click', function () {
        const parent = $(this).parents('.nav-list')
        if (parent.hasClass('checked')) {
          parent.removeClass('checked')
        } else {
          parent.addClass('checked')
        }
      })

      $(this).find('.le-country-region .le_icon--close').on('click', function () {
        $('.le-country-region').hide()
      })

      $(this).find('.country-region-btn').on('click', function () {
        $('.le-country-region').show()
      })
    }
  }

  customElements.define('footer-component', FooterComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lepro-back-to-school-sale"]) return;
  try {
    
class LeBackSilider extends LeCommunityShare {
  constructor() {
    super();

    this.mediaAggt = {
      ugc: [
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__ugc-1.jpg?v=1753943990' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__ugc-2.jpg?v=1753944641' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__ugc-3.jpg?v=1753944643' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__ugc-4.jpg?v=1753944640' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__ugc-5.jpg?v=1753944641' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__ugc-6.jpg?v=1753944643' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__ugc-7.jpg?v=1753944641' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__ugc-8.jpg?v=1753944642' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__ugc-9.jpg?v=1753944641' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__ugc-10.png?v=1753944642' }
      ],
      say: [
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-1.png?v=1753952618', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/88fece7070934aac89931c94667ae364.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-2.png?v=1753952616', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/e457f7f959b44a55a6614287213bc696.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-7.png?v=1753952619', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/f2b5ce64578746f1b9a27ca2d0a44e01.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-3.png?v=1753952618', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/b79879fc70fb41baaa9771ceca8ab9a3.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-4.png?v=1753952618', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/961a0eb4f19f4b578f096dd92373b03a.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-5.png?v=1753952616', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/13687209b4204ca895588508e111b554.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-6.png?v=1753952618', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/1d4db0ff64a0471dab9adcb0ec3a1e90.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-8.png?v=1753952618', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/de859cf0139d481cb81ef925dba6147e.mp4' }
      ]
    }
  }
}

customElements.define('le-back-silider', LeBackSilider);

class LeBackToMain extends LeLazyTool {
  constructor() {
    super();

    this.timer = null
    this.countDownEndAt = '2025-08-15T23:59:59Z'

    this.startCountDown()
  }

  addHtml(type) {
    switch (type) {
      case 'ugc':
      case 'say':
        const blockNode = document.querySelector(`le-back-silider[data-role="${type}"]`)
        blockNode.init()
        break
      default:
        break
    }
  }

  startCountDown() {
    this.timer = setInterval(() => {
      this.initCountDown()
    }, 1000)

    this.querySelector('.count-down-section').style.display = 'flex'
  }

  // init count down component
  initCountDown() {
    const currentDate = new Date(this.formatterTime(new Date())).getTime()
    const endAt = new Date(this.countDownEndAt.replace('Z', '')).getTime()
    
    let timeStamp = endAt - currentDate
    if (timeStamp <= 0) {
    // if (timeStamp > 0) {
      timeStamp = 0
      this.clearTimer()
    }

    this.combinationNode(timeStamp)
  }

  // count down html
  combinationNode (timestamp) {
    let seconds = Math.floor(timestamp / 1000)
    const days = Math.floor(seconds / (24 * 3600))
    seconds %= 24 * 3600
    const hours = Math.floor(seconds / 3600)
    seconds %= 3600
    const minutes = Math.floor(seconds / 60)
    seconds %= 60

    const dd = String(days).padStart(2, '0');
    const hh = String(hours).padStart(2, '0');
    const mm = String(minutes).padStart(2, '0');
    const ss = String(seconds).padStart(2, '0');

    const formatted = `<div class="count-down-number-item">
        <div class="number">${dd}</div>
        <div class="unit">Days</div>
      </div>
      <div class="count-down-number-item">
        <div class="round">:</div>
      </div>
      <div class="count-down-number-item">
        <div class="number">${hh}</div>
        <div class="unit">Hours</div>
      </div>
      <div class="count-down-number-item">
        <div class="round">:</div>
      </div>
      <div class="count-down-number-item">
        <div class="number">${mm}</div>
        <div class="unit">Mins</div>
      </div>
      <div class="count-down-number-item">
        <div class="round">:</div>
      </div>
      <div class="count-down-number-item">
        <div class="number">${ss}</div>
        <div class="unit">Secs</div>
      </div>`

    const countDownNode = this.querySelector('.count-down-section .count-down-number')
    countDownNode.innerHTML = formatted
  }

  // format time
  formatterTime (date) {
    const formatter = date.toLocaleString('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    })
    return formatter.replace(/24:/, '00:')
  }

  clearTimer () {
    clearInterval(this.timer)
    this.timer = null
  }
}

customElements.define('lepro-back-to-main', LeBackToMain);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lepro-how-to"]) return;
  try {
    
  $(function () {
    const storage_lang_key = 'lang'
    const storage_product_key = 'product'
    let lang = 'EN'
    const selectProduct = []
    const allVideos = window.LeAllVideos || {}

    let currentVideos = null

    const dialogSelectProduct = []
    let dialogLang = ''

    const videoItemNode = $('#video-item-node')
    const filterDialog = $('.lepro-filter-dialog')

    init()

    function init () {
      if (isFirstLoad()) {
        openDialog()
      }
      setPageContent()
      getVideos()
      initVideoNodes()
    }

    function getVideos() {
      if (selectProduct.length) {
        const filterVideos = {}

        for (const key in allVideos[lang]) {
          const videoInfo = allVideos[lang][key]
          const hasCommon = videoInfo.products.some(item => selectProduct.includes(item))
          if (hasCommon) {
            filterVideos[key] = videoInfo
          }

          if ((!videoInfo.products || videoInfo.products.length == 0) && !filterVideos[key]) {
            filterVideos[key] = videoInfo
          }
        }

        currentVideos = filterVideos
        return
      }

      currentVideos = allVideos[lang]
    }

    function initVideoNodes () {
      let node = ''

      if (currentVideos && Object.keys(currentVideos).length) {
        for (const key in currentVideos) {
          const item = currentVideos[key]
          node += `<div class="item">
            <div class="video-wrap">
              <iframe id="video-iframe__${key}" data-id="${key}" class="video-iframe" data-lazy-src="https://www.youtube.com/embed/${key}?enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              <img src="${item.cover}" alt="" class="video-cover">
              <div class="play-btn flex align-center justify-center">
                <svg class="le_icon" viewBox="0 0 1024 1024" width="28" height="28"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_play"></use></svg>
              </div>
            </div>
  
            <div class="title">${item.title}</div>
          </div>`
        }
      }

      videoItemNode.html(node)
    }

    function isFirstLoad () {
      const currentLang = getLocalStorage(storage_lang_key)
      const currentProduct = getLocalStorage(storage_product_key)
      
      if (currentLang) {
        lang = currentLang
        if (currentProduct) {
          selectProduct.push(...currentProduct.split(','))
        }
        return false
      }

      setLocalStorage(storage_lang_key, lang)
      setLocalStorage(storage_product_key, selectProduct.join(','))
      return true
    }

    function openDialog () {
      dialogSelectProduct.splice(0)
      dialogSelectProduct.push(...selectProduct)

      dialogLang = lang

      initTagActive()
      initProducts()
      setSelectProdut()

      filterDialog.css({ display: 'flex' })
    }

    function initTagActive () {
      filterDialog.find('.tags .tag').removeClass('active')
      filterDialog.find(`.tags .tag[data-type="${dialogLang}"]`).addClass('active')
    }

    function initProducts () {
      let node = ''

      const currentLangProducts = allVideos[dialogLang]
      const currentLangProductsNames = []

      for (const key in currentLangProducts) {
        const data = currentLangProducts[key]
        if (data.products && data.products.length) {
          currentLangProductsNames.push(...data.products)
        }
      }

      const uniqueArr = currentLangProductsNames.filter((item, index) => {
        return currentLangProductsNames.indexOf(item) === index
      })

      if (window.LeProducts && window.LeProducts.length) {
        const products = window.LeProducts.filter((item, index) => {
          return uniqueArr.indexOf(item.name) > -1
        })

        products.forEach((item) => {
          node += `<div class="list ${dialogSelectProduct.indexOf(item.name) > -1 ? 'active' : ''}" data-type="${item.name}">
            <div class="img-wrap">
              <img src="${item.product_img}" alt="${item.name}" class="img">

              <div class="select-icon">
                <svg class="le_icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_select_on"></use></svg>
              </div>
            </div>

            <div class="list-name bold text-overflow">${item.name}</div>
          </div>`
        })
      }

      $('#product-list').html(node)
    }

    function setSelectProdut() {
      const tagNode = filterDialog.find('.product-lists .list')
      tagNode.removeClass('active')
      tagNode.map((index) => {
        if (dialogSelectProduct.indexOf($(tagNode[index]).attr('data-type')) > -1) {
          $(tagNode[index]).addClass('active')
        }
      })
    }

    function setPageContent () {
      $('.header-filter .filter-btn text').text(lang)
      if (selectProduct.length) {
        $('.header-filter .filter-product').text(selectProduct.join(','))
      } else {
        $('.header-filter .filter-product').text('All')
      }
    }

    const YT_PlayItems = {}
    let currentPalyYt = null

    filterDialog.on('click', function (e) {
      if ($(e.target).hasClass('le-how-dialog')) {
        filterDialog.hide()
      }
    })
    filterDialog.find('.confirm-btn').on('click', function () {
      lang = dialogLang
      selectProduct.splice(0)
      selectProduct.push(...dialogSelectProduct)

      setLocalStorage(storage_lang_key, lang)
      setLocalStorage(storage_product_key, selectProduct.join(','))
      getVideos()
      initVideoNodes()
      setPageContent()
      filterDialog.hide()
    })
    filterDialog.find('.dialog-wrap').on('click', function (e) {
      // e.stopPropagation()
    })
    $('body').on('click', '.lepro-filter-dialog .product-lists .list', function () {
      const dataType = $(this).attr('data-type')

      const productIndex = dialogSelectProduct.indexOf(dataType)
      if (productIndex > -1) {
        $(this).removeClass('active')

        dialogSelectProduct.splice(productIndex, 1)
        return
      } 

      dialogSelectProduct.push(dataType)
      $(this).addClass('active')
    })
    filterDialog.find('.tags .tag').on('click', function () {
      const dataType = $(this).attr('data-type')
      dialogLang = dataType
      $(this).siblings('.tag').removeClass('active')
      $(this).addClass('active')

      dialogSelectProduct.splice(0)

      initProducts()
      setSelectProdut()
    })

    $('#select-all').on('click', function () {
      if (dialogSelectProduct.length < window.LeProducts.length) {
        const allSelect = []
        window.LeProducts.forEach((item) => {
          allSelect.push(item.name)
        })
        dialogSelectProduct.splice(0)
        dialogSelectProduct.push(...allSelect)
      } else {
        dialogSelectProduct.splice(0)
      }

      setSelectProdut()
    })

    $('#header-filter').on('click', function () {
      filterDialog.css({ display: 'flex' })
      openDialog()
    })

    $('body').on('click', '.lepro-video-block .item .play-btn', function () {
      const parents = $(this).parents('.video-wrap')
      const videoNode = parents.find('.video-iframe')
      const lazySrc = videoNode.attr('data-lazy-src')
      const dataId = videoNode.attr('data-id')
      videoNode.attr('src', lazySrc)
      videoNode.removeAttr('data-lazy-src')

      $(this).hide()
      parents.find('.video-cover').hide()

      const eleId = `video-iframe__${dataId}`
      YT_PlayItems[eleId] = new YT.Player(eleId, {
        events: {
          onReady: (event) => {
            event.target.playVideo()
          },
          onStateChange: (event) => {
            if (event.data == 3) {
              if (currentPalyYt) {
                YT_PlayItems[currentPalyYt].pauseVideo()
              }
              currentPalyYt = eleId
            }
          }
        }
      })
    })

    function getLocalStorage (key) {
      return localStorage.getItem(key)
    }
    function setLocalStorage (key, value) {
      return localStorage.setItem(key, value)
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  var element, scriptTag;
  element = document.createElement('script');
  scriptTag = document.getElementsByTagName('script')[0];

  element.async = true;
  element.src = 'https://www.google.com/recaptcha/api.js'
    + '?onload=globalOnRecaptchaOnLoadCallback&render=explicit';
  scriptTag.parentNode.insertBefore(element, scriptTag);

  } catch(e) { console.error(e); }
})();
})();
